import instance from './axiosInstance';

function getConfigData(http = instance) {
  return http.get('/config/errorcode');
}

function updateConfigData(reqBody, options = {}, http = instance) {
  return http.post('/config/errorcode', reqBody, options);
}

function getLogData(http = instance) {
  return http.get('/config/errorcode/logs');
}

export {
  getConfigData,
  updateConfigData,
  getLogData,
};
